// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.scrollbar[data-v-6f832816] {\n    position: relative;\n    height: 422px;\n    width: 100%;\n    overflow-y: auto;\n    border-bottom: 1px solid #ddd;\n}\n\n", ""]);
// Exports
module.exports = exports;
